// main.jsx
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import * as ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import DashboardPage from './pages/DashboardPage.jsx';
import Login from './pages/Login.jsx';

import Layout from './layout/Layout.jsx';

import ProtectedRoute from './components/ProtectedRoute.jsx';

import Register from './pages/Register.jsx';
import ForgotPassword from './components/ForgotPassword.jsx';
import logger from './utils/logger';

import OptionsPage from './pages/OptionsPage.jsx';

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: '/',
        Component: Layout,
        children: [
          {
            path: '/',
            Component: () => (
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            ),
          },

          {
            path: '/options',
            Component: () => (
              <ProtectedRoute>
                <OptionsPage />
              </ProtectedRoute>
            ),
          },

          // Добавьте другие маршруты
        ],
      },
      {
        // Логин не использует Layout
        path: '/login',
        Component: Login,
      },
      {
        // Логин не использует Layout
        path: '/register',
        Component: Register,
      },
      {
        // Логин не использует Layout
        path: '/forgot',
        Component: ForgotPassword,
      },
    ],
  },
]);

createRoot(document.getElementById('root')).render(<RouterProvider router={router} />);
